import {
  getCasedHeadingTextBasedOnStyleOverrides,
  prepareComplaintSuffix,
} from 'src/mentor/components/PrescriptionMakingPage/printComponents/printComponents/prescriptionPrintableItems/util'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { PMPBodySectionItems } from './styledComponent'
import { applyNameCase, getSectionListFormatConfig } from './sectionListFormat'

// Complaint name (key) vs the duration/severity suffix (value) — coerce the name to text so an
// object label never renders as a React child (React error #31).
function getComplaintName(item) {
  const raw = item?.label ?? item?.title
  if (raw && typeof raw === 'object') {
    return raw.title ?? raw.label ?? raw.value ?? raw.name ?? ''
  }
  return raw
}

export default function PrintableComplaints({
  complaintsRef,
  debug,
  selectedComplaints,
  debugHighlightStates,
  styleOverrides,
  listItemSeparator,
}) {
  const cfg = getSectionListFormatConfig(styleOverrides, listItemSeparator)
  const complaintsToShow = (selectedComplaints || []).filter((item) => !!getComplaintName(item))
  const nameStyle = { fontWeight: cfg.bold ? 700 : 'inherit', color: cfg.keyColor || 'inherit' }
  const valueStyle = { color: cfg.valueColor || 'inherit' }
  const renderComplaintItem = (item) => (
    <>
      <span style={nameStyle}>{applyNameCase(getComplaintName(item), cfg.capitalize)}</span>
      <span style={valueStyle}>{prepareComplaintSuffix(item)}</span>
    </>
  )

  return (
    <PMPBodySectionItems
      ref={complaintsRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.complaints?.color}
      debugHighlight={debugHighlightStates?.complaints}
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Complaints',
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
        className={cfg.isBullet ? '' : 'd-flex align-items-center gap-1 flex-wrap'}
      >
        {cfg.isBullet ? (
          <ul style={{ margin: 0, paddingLeft: '20px' }}>
            {complaintsToShow.map((complaintItem, idx) => (
              <li key={idx}>{renderComplaintItem(complaintItem)}</li>
            ))}
          </ul>
        ) : (
          complaintsToShow.map((complaintItem, idx) => (
            <div style={{ paddingRight: '6px' }} key={idx}>
              {renderComplaintItem(complaintItem)}
              {complaintsToShow?.length - 1 !== idx && cfg.separator}
            </div>
          ))
        )}
      </div>
    </PMPBodySectionItems>
  )
}
